import type { $Fetch } from 'ofetch';
import type { RequerimentoGateway } from '@/application/port/out/RequerimentoGateway';
import type { Requerimento } from '@/domain/model/Requerimento';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

export class HttpRequerimentoGateway implements RequerimentoGateway {
  constructor(private readonly client: $Fetch) {}

  async listByAluno(alunoId: string): Promise<Requerimento[]> {
    const res = await this.client<ApiResponse<Requerimento[]>>(
      `/api/v1/requerimentos/aluno/${encodeURIComponent(alunoId)}`, { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }
}
